const accountResultsGrades = document.querySelectorAll('.account-results__grade');
const graduationNumber = 5.5;

if (accountResultsGrades.length) {
    [].forEach.call(accountResultsGrades, grade => {
        if (grade.innerText < graduationNumber) {
            grade.classList.add('color--warning');
        }
    });
}